import { useEffect, useState, useRef } from 'react';
import car_1_global from '../../Assets/car_1_global.png';
import car_2_global from '../../Assets/car_2_global.png';
import car_3_global from '../../Assets/car_3_global.png';
import * as S from './HowItWorksSection.styles'

export const HowItWorksSection = () => {
  const [blurIndexes, setBlurIndexes] = useState(new Set());
  const cardsRef = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      const newBlurIndexes = new Set();

      cardsRef.current.forEach((card, index) => {
        if (!card) return;
        const rect = card.getBoundingClientRect();

        if (index > 0) {
          const prevCard = cardsRef.current[index - 1];
          if (!prevCard) return;
          const prevRect = prevCard.getBoundingClientRect();

          const overlapDistance = prevRect.bottom - rect.top;

          if (overlapDistance >= 10) {
            newBlurIndexes.add(index - 1);
          }
        }
      });

      let hasChange = false;
      if (blurIndexes.size !== newBlurIndexes.size) {
        hasChange = true;
      } else {
        for (const i of newBlurIndexes) {
          if (!blurIndexes.has(i)) {
            hasChange = true;
            break;
          }
        }
      }

      if (hasChange) {
        setBlurIndexes(newBlurIndexes);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [blurIndexes]);
  return (
    <S.CardsBox id='how-it-works'>
      {[car_1_global, car_2_global, car_3_global].map((img, index) => (
        <S.Card
          key={index}
          ref={(el) => (cardsRef.current[index] = el)}
          className={`card-scroll ${blurIndexes.has(index) ? 'blur-card' : ''
            } ${index === 1 ? 'flex-col items-center' : ''}`}
          style={{ zIndex: index + 1, top: `${100 + index * 20}px` }}
        >
          {index === 0 && (
            <>
              <img
                src={img}
                alt="card-1"
                className='
                  hidden
                  lg:block
                '
                style={{
                  height: '279px',
                  marginTop: '-94px'
                }}
              />
              <div
                className='
                  mb-[128px]
                  lg:mb-0
                '
              >
                <S.CardTitle>
                  Your Business Sends the Payment
                </S.CardTitle>
                <S.CardText>
                  You organize and initiate the transaction — securely and efficiently — from your platform.
                </S.CardText>
              </div>

              <img
                src={img}
                alt="card-1"
                className='
                  lg:hidden
                  h-[142px]
                  lg:h-[279px]
                  absolute
                  -bottom-1
                '
              />
            </>
          )}

          {index === 1 && (
            <>
              <img
                src={img}
                alt="card-2"
                style={{
                  marginTop: '-94px'
                }}
                className='
                  w-[276px]
                  lg:w-[433px]
                '
              />
              <div
                className='
                lg:-mt-[24px]
              '
              >
                <S.CardTitle
                  className="text-center"
                >
                  Processed by PayQuest
                </S.CardTitle>
                <S.CardText
                  className="text-center"
                >
                  Your payment flows through our secure infrastructure — with full compliance and FX conversion.
                </S.CardText>
              </div>
            </>
          )}

          {index === 2 && (
            <div
              className='
                block
                lg:flex
                '
            >
              <div
                className='
                  mb-[36px]
                  lg:mb-0
                '
              >
                <S.CardTitle>
                  Customer receives instantly via PIX
                </S.CardTitle>
                <S.CardText>
                  The user gets the funds in seconds — with full transparency, speed, and local currency.
                </S.CardText>
              </div>
              <img
                src={img}
                alt="card-3"
                className='
                  w-[326px]
                  lg:w-[454.56px]
                  lg:h-[364px]
                  -mb-12
                  block
                  mx-auto
                  lg:-mt-[188px]
                  lg:-mr-[100px]
                '
              />
            </div>
          )}
        </S.Card>
      ))}
    </S.CardsBox>
  )
}
